import { useDecision } from '@optimizely/react-sdk'

export const VALUE_BANNER_WEB_FLAG = 'turnips_ofx_value_banner_web'

export const useValueBannerFeatureFlag = () => {
  const [decision] = useDecision(VALUE_BANNER_WEB_FLAG)

  return decision.variationKey === 't1'
}
